import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000'
const AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
export const setupApiInterceptors = (getAccessToken: (options?: { authorizationParams?: { audience?: string } }) => Promise<string>) => {
  api.interceptors.request.use(
    async (config) => {
      try {
        console.log('🔐 Requesting access token with audience:', AUDIENCE)

        // Request token with API audience
        const token = await getAccessToken({
          authorizationParams: {
            audience: AUDIENCE
          }
        })

        if (token) {
          console.log('✅ Got access token (first 20 chars):', token.substring(0, 20) + '...')

          // Decode to check claims (just for debugging)
          try {
            const parts = token.split('.')
            if (parts.length === 3) {
              const payload = JSON.parse(atob(parts[1]))
              console.log('📋 Token claims:', payload)
            }
          } catch (e) {
            console.error('Failed to decode token:', e)
          }

          config.headers.Authorization = `Bearer ${token}`
        } else {
          console.warn('⚠️ No token received')
        }
      } catch (error) {
        console.error('❌ Failed to get access token:', error)
        throw error
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )
}

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized error
      console.error('Unauthorized - redirecting to login')
    }
    return Promise.reject(error)
  }
)

export default api
